function tokenFromArray(value) {
  return {
    id: value[0],
    newLength: value[1],
    newIndex: value[2],
    lemmas: value[3],
    lemmatized: value[4],
    idx: value[5],
    length: value[6],
  }
}

function inferDocumentTokenType(formDoc) {
  const form = String(formDoc || '').trimStart()
  if (/^<punct(?:\s|>)/.test(form)) return 'punct'
  if (/^<num(?:\s|>)/.test(form)) return 'num'
  return 'occ'
}

function normalizeDocumentToken(value, document, options = {}) {
  const isStaticTuple = Array.isArray(value)
  const token = Array.isArray(value) ? tokenFromArray(value) : { ...value }

  // Static token exports contain positions; DocumentDetails needs the source
  // slice. Backend responses already provide formDoc.
  if (token.formDoc === undefined && typeof document?.content === 'string' &&
      Number.isInteger(token.idx) && Number.isInteger(token.length)) {
    token.formDoc = document.content.slice(token.idx, token.idx + token.length)
  }

  // Legacy static tuples omit tokentype. The XML token form is the source of
  // truth used by the importer: punct/num have explicit wrappers; every other
  // token, including zero-length footnote anchors, is an occurrence token.
  if (token.tokentype === undefined &&
      (isStaticTuple || options.inferTokenType) &&
      typeof token.formDoc === 'string') {
    token.tokentype = inferDocumentTokenType(token.formDoc)
  }

  return token
}

function normalizeDocumentTokens(values, document, options) {
  if (!Array.isArray(values)) return values
  return values.map(value => normalizeDocumentToken(value, document, options))
}

export {
  inferDocumentTokenType,
  normalizeDocumentToken,
  normalizeDocumentTokens,
}
